import { useState, useRef, Fragment } from "react";
import Config from "../../Config";
import AppContext from "../../AppContext";
import InputComboRok from "../../helpers/InputComboRok";
import InputComboMiesiac from "../../helpers/InputComboMiesiac";
import InputTextAlpha from "../../helpers/InputTextAlpha";
import FormatTime from "../../helpers/FormatTime";



function EmpSum(props)
{
    const [refreshView, setRefreshView] = useState(props.userData.refreshView);


    const [filter, setFilter] = useState(null);
    const [filterParam, setFilterParam] = useState({
        p_imie_nazwisko: props.mainView.readFilter('p_imie_nazwisko',''),         
        rok: (new Date()).getFullYear() ,
        miesiac: (new Date() ).getMonth()+1,   
        show: true,           
    });
    const [tab, setTab] = useState(null);  



    
    const filterView = () => {
        setFilterParam(  {...filterParam, ["show"]:!filterParam.show } );
    }


    const filterClear = () => {

        props.mainView.writeFilter('p_imie_nazwisko', '');


        setFilterParam({
            p_imie_nazwisko: '',            
            rok: (new Date()).getFullYear() ,
            miesiac: (new Date() ).getMonth()+1,                    
        });
        setTab(null);
    }

    const filterApprove = () => {   
        setTab(null)     
    }


    const valChangeListener = (filedName, val, correct, msg) => {

        // console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg);
 
         setFilterParam( {...filterParam, [filedName]:val,  [filedName+"_valid"]:correct } );
         
         if(   (val.length == 0 || val.length > 2 || msg =='combo')  && filterParam[filedName] != val )
            {
                    var defTimeOut = 1000;
                    if(msg == 'combo') defTimeOut = 10;
                    clearTimeout(AppContext.timeoutId);
                    AppContext.timeoutId = setTimeout( () => {
                        setTab(null); 
                    } , defTimeOut );
            }

         props.mainView.writeFilter(filedName, val);
     }



     const goNextNew = () => {
        console.log("goNext");    
        setTab(null);    
    }







    const getTab = () => {
       
 
        props.mainView.setProgress(-2);

       

        fetch( Config.url + '/rest_v1_emps,review', {
            method: 'POST', 
            body: JSON.stringify(filterParam), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        setTab(res.result);                             
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
                   

         return false;
    }





    if(tab == null)
        {
            setTab([]);
            getTab();
         
    
            return <div>
                ...
            </div>
        }

    if(refreshView != props.userData.refreshView)
        {         
            setRefreshView( props.userData.refreshView);
            setTab(null);           
        }




        var sumMinGrafik     = 0;
        var sumMinGodz       = 0;
        var sumMinNadgodziny = 0;
        var sumUrlopy        = 0;


        for(var k=0; k<tab.length; k++)
        {
            for(var g=0; g<tab[k].grafik.length; g++ )
            {
                sumMinGrafik       =  sumMinGrafik +  tab[k].grafik[g].czas_min;
            }

            
            sumMinGodz         =  sumMinGodz +  tab[k].ob_godziny_min;
            sumMinNadgodziny   =  sumMinNadgodziny +  tab[k].ob_nadgodziny_min;
            sumUrlopy          =  sumUrlopy +  tab[k].urlopy.length;

        }


        return  <div className="view_content">


                             <div className="table_filter">
                                    
                                            

                                    <div className="filter_controll">   
                                        <label>Rok: </label>                             
                                        <InputComboRok   userData={props.userData}  mainView={props.mainView}  value={filterParam.rok}   valChange={valChangeListener} goNext={goNextNew} name="rok" placeholder={": "}  noempty="1"   />
                                    </div> 

                                    <div className="filter_controll">   
                                        <label>Miesiąc: </label>                             
                                        <InputComboMiesiac   userData={props.userData}  mainView={props.mainView}  value={filterParam.miesiac}   valChange={valChangeListener} goNext={goNextNew} name="miesiac" placeholder={": "}  noempty="1"   />
                                    </div> 

                                    <div className="filter_controll">   
                                        <label>Pracownik: </label>                             
                                        <InputTextAlpha   userData={props.userData} value={filterParam.p_imie_nazwisko}   valChange={valChangeListener} goNext={goNextNew} name="p_imie_nazwisko" placeholder={"Pracownik: "}   />
                                    </div> 


                                    <div className="filter_btn">
                                        
                                        <span className="btn" onClick={filterApprove} >filtruj</span>&nbsp;&nbsp;<span className="btn" onClick={filterClear} >wyczyść</span>
                                    </div>

                            </div>
             
                            <div className=" bg_center">

                                    <div className="scorll_x">
                                            <table className="table">            

                                                <thead>
                                                        <tr className="header">                                                                
                                                            <td className="td_left gocenter">LP</td>     
                                                            <td>Osoba</td>  
                                                            <td>Dzień</td>                                                                  
                                                            <td>Grafik pracy</td>        
                                                            <td>Il. godz. wg. grafika</td>        
                                                            <td>Zarej. wejście</td>        
                                                            <td>Zarej. wyjście</td>        
                                                            <td>Il. godziny</td>        
                                                            <td>Il. nadgodziny</td>        
                                                            <td className="td_right">Zgłoszony urlop</td>                                                            
                                                        </tr>
                                                </thead>

                                                <tbody>
                                                    {
                                                        tab.map( (row, ix) => {

                                                            var rowStyle = " row ";
                                                            if(ix % 2 == 0 )rowStyle = " row2 ";

                                                            return <tr className={rowStyle} >                                                                
                                                                <td className="td_left gocenter">{ix+1}</td>     
                                                                <td className="gocenter">{row.nazwisko + " " + row.imie}</td>  
                                                                <td className="gocenter">{row.dzien}</td>          
                                                                <td className="gocenter">{row.grafik.od + " / " + row.grafik.do}</td>        
                                                                <td className="gocenter">{row.grafik.czas}</td>        
                                                                <td className="gocenter">{row.wejscie}</td>        
                                                                <td className="gocenter">{row.wyjscie}</td>        
                                                                <td className="gocenter">{row.ob_godziny}</td>        
                                                                <td className="gocenter">{row.ob_nadgodziny}</td>        
                                                                <td className="td_right">
                                                                    <table className="table">
                                                                        {
                                                                            row.urlopy.map( (u, uInx) => {
                                                                                return <tr>
                                                                                    <td>{u.skr}</td>
                                                                                    <td>{u.nazwa}</td>
                                                                                </tr>
                                                                            } )
                                                                        }
                                                                    </table>                                                                    
                                                                </td>                                                            
                                                            </tr>


                                                        } )
                                                    }

                                                        <tr>                                                                
                                                            <td>&nbsp;</td>     
                                                            <td>&nbsp;</td>  
                                                            <td>&nbsp;</td>                                                                  
                                                            <td>&nbsp;</td>        
                                                            <td className="gocenter gobold"><FormatTime minute={sumMinGrafik}/> </td>        
                                                            <td>&nbsp;</td>        
                                                            <td>&nbsp;</td>        
                                                            <td className="gocenter gobold"><FormatTime minute={sumMinGodz}/></td>        
                                                            <td className="gocenter gobold"><FormatTime minute={sumMinNadgodziny}/></td>        
                                                            <td className="gocenter gobold">{sumUrlopy}</td>                                                            
                                                        </tr>

                                                </tbody>

                                            </table>
                                    </div>
                            </div>


        </div>
}



export default EmpSum;